import { useState, useEffect } from 'react';
import { fetchAllProperties } from '../api';
import { Property } from '../types';

export const useFetchProperties = () => {
  const [properties, setProperties] = useState<Property[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    const getProperties = async () => {
      try {
        setLoading(true);
        const data = await fetchAllProperties();
        if (isMounted) {
          setProperties(data);
        }
      } catch (err) {
        console.error(err);
        if (isMounted) {
          setError('Failed to fetch properties.');
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };
    
    getProperties();

    return () => {
      isMounted = false;
    };
  }, []);

  // Note: Real-time subscription removed - property data rarely changes.
  // Data is refetched on component mount and when needed.

  return { properties, setProperties, loading, error };
};
